import gql from 'graphql-tag';

const SEND_GET_IN_TOUCH_EMAIL = gql`
  query SendGetInTouchEmail($organisationId: String!, $userId: String!, $product: String!, $subject: String!, $optionalText: String)
  {
    sendGetInTouchEmail(organisationId: $organisationId, userId: $userId, product: $product, subject: $subject, optionalText: $optionalText)
  }`;

export default ((
organisationId,
userId,
product) => (
{
  query: SEND_GET_IN_TOUCH_EMAIL,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: ({ subject, optionalText }) => ({
    organisationId,
    userId,
    product,
    subject,
    optionalText
  }),
  isSilent: true
}));